import './index.scss'

const Projects = () => ('Hello')

export default Projects